import {fetchBody} from "../../config"
import { toLogout, cleanFetch } from "../apiTools";
import { getToken } from "../../component/Login/Auth";
import { URL_INCHARGE_DISTRIBUTION_GET_LIST, URL_INCHARGE_SALES_GET_LIST } from "../../setup/config_beer";

export function api_getInChargeSalesList ({companyId, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body:{companyId}, token}), 
      url: URL_INCHARGE_SALES_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
export function api_getInChargeDistributionList ({companyId, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body:{companyId}, token}), 
      url: URL_INCHARGE_DISTRIBUTION_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}